import { render, staticRenderFns } from "./comaSplit.vue?vue&type=template&id=2468fe25"
import script from "./comaSplit.vue?vue&type=script&lang=js"
export * from "./comaSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports